import * as zod from 'zod';

export const validationSchema = () =>
    zod.object({
        name: zod.string().min(1, { message: 'Banner name has to be at least one character long' }),
    });
